@if (show) {
  <div class="modal-overlay" (click)="onOverlayClick($event)">
    <div class="modal-content">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="icons.help"></fa-icon>
          <span>{{ title | translate }}</span>
        </h3>
        <button class="close-btn" (click)="onClose()">
          <fa-icon [icon]="icons.close"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <p class="help-text">{{ content | translate }}</p>
      </div>
    </div>
  </div>
}
